import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, ArrowRightIcon } from 'lucide-react';
export function OfferSection() {
  const basicFeatures = ['6 tomos del sistema', 'Ansiedad y raíz del problema', 'Reprogramación mental', 'Control físico', 'Confianza y dominio', 'Acceso inmediato'];
  const completeFeatures = ['6 tomos completos del sistema', 'Kegel avanzado y control profundo', 'Reset de estímulo y dopamina', 'Presencia y manejo con mujeres', 'Plan de acción 14 días', 'Audios hipnóticos de reprogramación', 'Sistema completo de transformación'];
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" id="checkout" data-id="element-279">
      {/* Cinematic red glow backdrop */}
      <div className="absolute inset-0 z-0" data-id="element-280">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-full bg-red-800/20 blur-[150px]" data-id="element-281" />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/60 to-black" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.7) 70%, #000 100%)'
      }} data-id="element-282" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-283" />
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-284" />

      <div className="relative z-20 max-w-6xl mx-auto px-6" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-286">
          <div className="flex items-center justify-center gap-3 mb-5" data-id="element-287">
            <div className="w-12 h-px bg-red-600" data-id="element-288" />
            <span className="text-red-500 text-xs md:text-sm uppercase tracking-[0.3em] font-bold" data-id="element-289">
              Tu Decisión
            </span>
            <div className="w-12 h-px bg-red-600" data-id="element-290" />
          </div>

          <h2 className="font-display text-4xl md:text-6xl uppercase mb-2 text-center text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.4)]" data-id="element-291">
            ELIGE TU ACCESO
          </h2>
          <p className="text-center text-gray-400 text-base md:text-lg mb-8" data-id="element-292">
            Dos formas de empezar tu transformación
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch" data-id="element-293">
            {/* BASIC OPTION */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/30 rounded-xl p-6 md:p-7 flex flex-col shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-294">
              <div className="mb-5" data-id="element-295">
                <div className="inline-flex items-center gap-2 bg-gray-800/50 border border-gray-700 text-gray-300 px-3 py-1 rounded-full text-xs font-semibold mb-4" data-id="element-296">
                  ⚪ ACCESO BÁSICO
                </div>
                <h3 className="font-display text-2xl md:text-3xl uppercase mb-2 text-white" data-id="element-297">
                  Empieza el cambio
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-298">
                  Los fundamentos del sistema
                </p>
              </div>

              <div className="mb-6" data-id="element-299">
                <div className="flex items-baseline gap-2" data-id="element-300">
                  <span className="text-gray-500 text-xl" data-id="element-301">$</span>
                  <span className="font-display text-4xl md:text-5xl text-white" data-id="element-302">
                    19.990
                  </span>
                </div>
                <p className="text-gray-500 text-xs mt-1 uppercase tracking-wider" data-id="element-303">
                  Pago único
                </p>
              </div>

              <div className="space-y-2.5 mb-6 flex-grow" data-id="element-304">
                <p className="font-bold text-gray-300 mb-3 uppercase tracking-wider text-xs" data-id="element-305">
                  Incluye:
                </p>
                {basicFeatures.map((feature, index) => <div key={index} className="flex items-start gap-2.5 text-gray-400 text-sm" data-id="element-306">
                    <CheckIcon className="w-4 h-4 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-307" />
                    <span data-id="element-308">{feature}</span>
                  </div>)}
              </div>

              {/* Basic CTA */}
              <a href="https://www.tiendamentalpro.online/cart/53212804579628:1" className="group relative block w-full" data-id="element-309">
                <div className="absolute -inset-0.5 bg-gray-700 rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-500" data-id="element-310" />
                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="relative w-full flex items-center justify-center gap-2 bg-gradient-to-b from-gray-800 to-gray-900 text-white font-display text-base md:text-lg uppercase tracking-wider py-4 rounded-xl border border-gray-700 shadow-lg transition-all duration-300" data-id="element-311">
                  👉 Quiero empezar – $19.990
                  <span className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/5 to-transparent rounded-t-xl pointer-events-none" data-id="element-312" />
                </motion.button>
              </a>
            </motion.div>

            {/* COMPLETE OPTION - HIGHLIGHTED */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-600 rounded-xl p-6 md:p-7 flex flex-col shadow-[0_0_50px_rgba(220,38,38,0.2)] lg:scale-105 lg:-my-3 overflow-hidden" data-id="element-313">
              <div className="absolute inset-0 bg-red-600/5 blur-3xl" data-id="element-314" />

              {/* Recommended Badge */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-gradient-to-r from-red-600 to-red-800 text-white font-bold text-xs uppercase tracking-widest px-6 py-1.5 rounded-b-xl flex items-center gap-2 shadow-[0_5px_15px_rgba(220,38,38,0.4)] border-x border-b border-red-400/30" data-id="element-315">
                <StarIcon className="w-3.5 h-3.5 fill-white" data-id="element-316" />
                Más elegido — Recomendado
                <StarIcon className="w-3.5 h-3.5 fill-white" data-id="element-317" />
              </div>

              <div className="mb-5 mt-5 relative" data-id="element-318">
                <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-600/50 text-red-400 px-3 py-1 rounded-full text-xs font-bold mb-4 shadow-[0_0_15px_rgba(220,38,38,0.2)]" data-id="element-319">
                  🔴 ACCESO COMPLETO ⭐
                </div>
                <h3 className="font-display text-3xl md:text-4xl uppercase mb-2 text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" data-id="element-320">
                  El sistema completo
                </h3>
                <p className="text-red-400 font-semibold tracking-wide text-sm" data-id="element-321">
                  🔥 Más completo y más elegido
                </p>
              </div>

              <div className="mb-6 relative" data-id="element-322">
                <div className="flex items-baseline gap-2" data-id="element-323">
                  <span className="text-red-500 text-xl" data-id="element-324">$</span>
                  <span className="font-display text-5xl md:text-6xl text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-300 drop-shadow-[0_0_20px_rgba(255,255,255,0.2)]" data-id="element-325">
                    27.990
                  </span>
                </div>
                <p className="text-red-400/80 text-xs mt-1 uppercase tracking-wider font-semibold" data-id="element-326">
                  Pago único – Acceso de por vida
                </p>
              </div>

              <div className="space-y-2.5 mb-6 flex-grow relative" data-id="element-327">
                <p className="font-bold text-white mb-3 uppercase tracking-wider text-xs" data-id="element-328">
                  Incluye TODO:
                </p>
                {completeFeatures.map((feature, index) => <div key={index} className="flex items-start gap-2.5 text-sm" data-id="element-329">
                    <CheckIcon className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5 drop-shadow-[0_0_8px_rgba(220,38,38,0.6)]" data-id="element-330" />
                    <span className="text-gray-200 font-medium" data-id="element-331">{feature}</span>
                  </div>)}
              </div>

              {/* Premium CTA */}
              <a href="https://www.tiendamentalpro.online/cart/53212807987500:1" className="group relative block w-full mt-auto" data-id="element-332">
                <div className="absolute -inset-1 bg-red-600 rounded-xl blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500" data-id="element-333" />
                <div className="absolute -inset-0.5 bg-gradient-to-r from-red-700 via-red-500 to-red-700 rounded-xl blur opacity-80 group-hover:opacity-100 transition duration-500" data-id="element-334" />

                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="relative w-full flex items-center justify-center gap-3 bg-gradient-to-b from-red-600 to-red-800 text-white font-display text-lg md:text-xl uppercase tracking-wider py-5 rounded-xl border border-red-400/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_20px_50px_-15px_rgba(220,38,38,0.7)] transition-all duration-300" data-id="element-335">
                  <span className="drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]" data-id="element-336">
                    👉 Quiero todo el sistema – $27.990
                  </span>
                  <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-337" />
                  <span className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/15 to-transparent rounded-t-xl pointer-events-none" data-id="element-338" />
                </motion.button>
              </a>
            </motion.div>
          </div>

          {/* Trust line */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="mt-10 text-center" data-id="element-339">
            <p className="text-gray-400 text-xs md:text-sm uppercase tracking-widest flex flex-wrap items-center justify-center gap-x-5 gap-y-3" data-id="element-340">
              <span className="flex items-center gap-2" data-id="element-341">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-342" />
                Acceso inmediato
              </span>
              <span className="hidden md:inline text-red-900/50" data-id="element-343">|</span>
              <span className="flex items-center gap-2" data-id="element-344">
                <span className="text-red-500" data-id="element-345">💰</span>
                Pago único
              </span>
              <span className="hidden md:inline text-red-900/50" data-id="element-346">|</span>
              <span className="flex items-center gap-2" data-id="element-347">
                <span className="text-red-500" data-id="element-348">🔒</span>
                Contenido 100% digital y discreto
              </span>
            </p>
          </motion.div>

          {/* Closing line */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="mt-10 relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/50 p-6 md:p-7 rounded-lg max-w-3xl mx-auto shadow-[0_0_40px_rgba(220,38,38,0.1)]" data-id="element-349">
            <span className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-red-600" data-id="element-350" />
            <span className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-red-600" data-id="element-351" />
            <span className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-red-600" data-id="element-352" />
            <span className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-red-600" data-id="element-353" />

            <p className="text-base md:text-lg text-center flex flex-col md:flex-row items-center justify-center gap-3" data-id="element-354">
              <span className="text-2xl text-red-500" data-id="element-355">👉</span>
              <span className="leading-relaxed" data-id="element-356">
                <span className="text-white font-bold drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-357">
                  La mayoría elige el acceso completo
                </span>{' '}
                <span className="text-gray-400" data-id="element-358">
                  para obtener resultados más rápidos y profundos.
                </span>
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}